/**
 * KwikPass Event Functions
 * Functions to dispatch KwikPass-related events
 */
interface KwikPassProductEventData {
  product_id: string;
  variant_id?: string;
  image_url: string;
  name: string;
  price: number | string;
  handle: string;
  cart_id?: string;
}

export function dispatchProductViewEvent(data: KwikPassProductEventData): void {
  // Only run in browser environment
  if (typeof window === "undefined") return;

  const event = new CustomEvent("page_view_kp", {
    detail: {
      type: "product", // [format:string, Mandatory]
      data,
    },
  });

  window.dispatchEvent(event);
  console.info("#KwikPassEvent product view event dispatched", data);
}

interface KwikPassCollectionEventData {
  cart_id?: string;
  collection_id: string;
  name: string;
  image_url: string;
  handle?: string;
}

export function dispatchCollectionViewEvent(
  data: KwikPassCollectionEventData
): void {
  // Only run in browser environment
  if (typeof window === "undefined") return;

  const event = new CustomEvent("page_view_kp", {
    detail: {
      type: "collection", // [format:string, Mandatory]
      data,
    },
  });

  window.dispatchEvent(event);
  console.info("#KwikPassEvent collection view event dispatched", data);
}

interface KwikPassOtherPageEventData {
  cart_id?: string;
}
export function dispatchOtherPageViewEvent(
  data: KwikPassOtherPageEventData
): void {
  // Only run in browser environment
  if (typeof window === "undefined") return;

  const event = new CustomEvent("page_view_kp", {
    detail: {
      type: "other", // [format:string, Mandatory]
      data,
    },
  });

  window.dispatchEvent(event);
  console.info("#KwikPassEvent collection view event dispatched", data);
}
